// extracted by mini-css-extract-plugin
export var addButton = "_j8-0";
export var border = "_j8-8";
export var check = "_j8-h";
export var danger = "_j8-6";
export var dropdownContainer = "_j8-1";
export var editModalBody = "_j8-j";
export var footerContainer = "_j8-i";
export var fullWidth = "_j8-a";
export var hide = "_j8-9";
export var icon = "_j8-3";
export var input = "_j8-7";
export var inputFlex = "_j8-b";
export var inputWrapper = "_j8-c";
export var manualFocus = "_j8-5";
export var optionButton = "_j8-4";
export var pillWrapper = "_j8-e";
export var pointer = "_j8-2";
export var showOverflow = "_j8-f";
export var tagsFlex = "_j8-d";
export var xButton = "_j8-g";